// extracted by mini-css-extract-plugin
module.exports = {"loadingPanelWrapper":"hA"};